interface ChowNowAddressType {
  longitude: number;
  city: string;
  formatted_address: string;
  street_address: string;
  id: string;
  country: string;
  geo: string;
  state: string;
  name?: string;
  place_formatted_address: string;
  zip: string;
  country_alpha2: string;
  street_address1: string;
  is_google_place: boolean;
  latitude?: number;
  address_string: number;
}

export interface ChowNowOrderAheadType {
  is_delivery_ahead_available: boolean;
  is_pickup_ahead_available: boolean;
  is_curbside_ahead_available: boolean;
}

export interface ChowNowRestaurantMediaType {
  cover_image_url: string;
}

export interface ChowNowRestaurantType {
  id: number;
  is_pickup_available: boolean;
  distance: number;
  address: ChowNowAddressType;
  cuisines: Array<string>;
  phone: string;
  order_ahead: ChowNowOrderAheadType;
  is_curbside_available: boolean;
  primary_cuisine?: string;
  short_name: string;
  name: string;
  has_automatic_discount: boolean;
  next_pickup_time?: string;
  next_delivery_time?: string;
  is_delivery_available: boolean;
  next_curbside_time?: string;
  media?: ChowNowRestaurantMediaType;
  restaurant_company_id: string;
  default_automatic_discount_label: string;
}

export interface ChowNowFacetType {
  action?: string;
  tag: string;
  name?: string;
  next?: string;
  prev?: string;
  restaurants: Array<ChowNowRestaurantType>;
  total: number;
}

export interface SearchFiltersFromUrlType {
  deliversToMe: boolean;
  isOpen: boolean;
  hasCurbside: boolean;
  hasPromo: boolean;
  query?: string;
  loc: string;
  lat: string;
  lng: string;
  nwLat?: string;
  nwLng?: string;
  seLat?: string;
  seLng?: string;
}

export enum ChowNowFacetTag {
  IsNew = 'is_new',
  IsFavorite = 'is_favorite',
  LowCostDelivery = 'low_cost_delivery',
}
